import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../../../shared/lib/firebase';
import type { SupportMessage } from '../lib/types';

export function useTicketMessages(ticketId: string | undefined) {
  const [messages, setMessages] = useState<SupportMessage[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!ticketId) return;
    const q = query(
      collection(db, 'support_tickets', ticketId, 'messages'),
      orderBy('createdAt', 'asc'),
    );
    const unsub = onSnapshot(q, (snap) => {
      setMessages(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<SupportMessage, 'id'>) })));
      setLoading(false);
    }, (err) => { console.error('[useTicketMessages]', err); setLoading(false); });
    return unsub;
  }, [ticketId]);

  return { messages, loading };
}
